module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CloudChainAauditResult");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CloudChainAauditResult!./src/pages/Shop/Member/Personal/CloudChain/CloudChainAauditResult/index.js
// module id = 1619
// module chunks = 418